import { useRouteMatch } from 'react-router';
import { useMount } from 'react-use';

import { AiAssistantQrGenerateCommand } from '@dreryk/egabinet-ai-assistant-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent, LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { translationKeys } from '../../translations';

const t = translationKeys.mainMenuTileItem.soundSource;

type AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectLoaderRenderProps = Readonly<{ qrCodeUrl: string }>;

type AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectLoaderProps = {
   children: (renderProps: AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectLoaderRenderProps) => JSX.Element;
};

export const AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectLoader = (
   props: AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectLoaderProps
): JSX.Element => {
   const visitRouteMatch = useRouteMatch<{ visitId: string }>(visitPaths.VISIT_PATH);
   const visitId = Number(visitRouteMatch?.params.visitId);

   const { data: qrCodeUrl, execute: generateQrCode, loading: qrCodeLoading, error: qrCodeError } = useCqrsCommand<
      string,
      void
   >(
      () => {
         const command = new AiAssistantQrGenerateCommand();
         command.visitId = visitId;
         return command;
      },
      {
         onUnexpectedError: () => {
            dispatchSnackbarNegativeEvent(t.qrCodeGenerateFailed);
         },
      }
   );

   useMount(() => {
      generateQrCode();
   });

   if (qrCodeError) {
      return (
         <Message
            testId={'error'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   if (qrCodeLoading || !qrCodeUrl) {
      return <LoaderSpinner />;
   }

   return props.children({ qrCodeUrl: qrCodeUrl });
};
